import React, { createContext, useContext, useState } from 'react';
import PropTypes from 'prop-types';

const LowReadyContext = createContext({
    lowReady: false,
    setLowReady: () => {},
    LOW_READY_PENALTY: 0.6,
});

export const LowReadyProvider = ({ children }) => {
    const [lowReady, setLowReady] = useState(false);
    return (
        <LowReadyContext.Provider value={{ lowReady, setLowReady, LOW_READY_PENALTY: 0.6 }}>
            {children}
        </LowReadyContext.Provider>
    );
};

export const useLowReady = () => useContext(LowReadyContext);

LowReadyProvider.propTypes = {
    children: PropTypes.node.isRequired,
};
